import { getApi, postApi, putApi } from "./api";

export const AddProducts = async (data) => {
  try {
    const response = await postApi(
      "/Inventory/AddProduct", data
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};

export const UpdateProduct = async (data) => {
  try {
    const response = await postApi(
      "/Inventory/UpdateProduct", data
    );
    return response;

  } catch (error) {
    console(error);
    throw error.response?.data || error.message;
  }
};
export const UpdateProductStatus = async (id, isActive) => {
  return await putApi(`/Inventory/UpdateProductStatus/${id}/status`, {
    isActive,
  });
};

export const GetAllProduct = async () => {
    return await getApi(
        `/Inventory/GetAllProduct`
    );
};

export const GetProductById = async (id) => {
    return await getApi(
        `/Inventory/GetProductById/${id}`
    );
};